import { useContext, useEffect, useState } from "react"
import { DateTime } from "luxon"
import { lessonsContext } from "../providers/lessons.provider"
import { profileContext } from "../providers/profile.provider"
import { schoolContext } from "../providers/school.provider"
import { isSmartphone } from "../atoms/SmartphoneView"
import { getLessonsInRange } from "../utils/firestore.utils"
import { getWeekBounds } from "../utils/week.utils"

const NONE = []

// Le lezioni di un maestro in un giorno, in questo circolo, da titolare e da
// assistente. Quasi sempre ci sono già: la settimana che il telefono ascolta,
// o il giorno che il computer sta guardando, se il maestro è quello che si
// guarda. Solo per un altro giorno o un altro maestro si ascolta quel giorno
// e basta, finché serve.
function useCoachLessonsOnDate(coachID, date) {
	const { displayedCoachID } = useContext(profileContext)
	const { selectedSchool } = useContext(schoolContext)
	const { lessons, selectedDate, weekLessons } = useContext(lessonsContext)

	const isShown = Boolean(coachID && date) && coachID === displayedCoachID
	const inShownWeek =
		isShown && Boolean(weekLessons) && getWeekBounds(date).start === getWeekBounds(selectedDate).start
	const inShownDay = isShown && !isSmartphone && date === selectedDate
	const loaded = inShownWeek
		? (weekLessons[date] ?? NONE)
		: inShownDay
			? (lessons?.[selectedSchool]?.[date]?.[coachID] ?? NONE)
			: null

	const key =
		!loaded && coachID && date && selectedSchool ? `${coachID}|${selectedSchool}|${date}` : null
	const [ownLessons, setOwnLessons] = useState({ key: null, lessons: NONE })

	useEffect(() => {
		if (!key) return
		const day = DateTime.fromISO(date).toJSDate()
		return getLessonsInRange(coachID, selectedSchool, day, day, byDate =>
			setOwnLessons({ key, lessons: byDate[date] ?? NONE }),
		)
		// la chiave dice già tutto quello da cui dipende l'ascolto
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [key])

	if (loaded) return loaded
	return ownLessons.key === key ? ownLessons.lessons : NONE
}

export default useCoachLessonsOnDate
